import {Pipe, PipeTransform} from '@angular/core';
import {Party} from '../../../models/party.model';
import {Insured} from '../../../models/simplified-ocean-policy.model';

@Pipe({
    name: 'appFullName'
})
export class FullNamePipe implements PipeTransform {

    transform(party: Party | Insured): any {
        if (!party) {
            return '';
        }
        const fullParty = [];
        fullParty.push(party.firstName);
        fullParty.push(party.lastName);
        return fullParty
            .filter(Boolean)
            .join(' ')
            .replace(/(^[,\s]+)|([,\s]+$)/g, '');
    }
}
